import { useAuth } from "../../hooks/pages/useAuth";

import ContactTable from "../../components/admin/contact/ContactTable";
import ContactFilters from "../../components/admin/contact/ContactFilters";
import ContactPagination from "../../components/admin/contact/ContactPagination";

import { useContactManagement } from "../../hooks/admin/contact/useContactManagement";

export default function ManageContacts() {
    const { user } = useAuth();

    const {
        contacts,
        loading,

        page,
        totalPages,

        filters,

        setPage,

        handleFilterChange,
        applyFilters,

        updateStatus,
    } = useContactManagement();

    const handleSubmit = (e) => {
        e.preventDefault();
        applyFilters();
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">
                Quản lý liên hệ
            </h1>

            <ContactFilters
                filters={filters}
                onChange={handleFilterChange}
                onSubmit={handleSubmit}
            />

            {loading ? (
                <p>Đang tải...</p>
            ) : (
                <>
                    <ContactTable
                        contacts={contacts}
                        isAdmin={user?.role === "admin"}
                        onStatusChange={updateStatus}
                    />

                    <ContactPagination
                        page={page}
                        totalPages={totalPages}
                        onPageChange={setPage}
                    />
                </>
            )}
        </div>
    );
}